module.exports = __webpack_public_path__ + "img/Luke.ef3d873d.jpeg";